import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromState from './dto.state'
import { DTO_REDUCER } from './dto.reducer'
import { EffectsModule } from '@ngrx/effects'
import { DtoEffects } from './dto.effects'

@NgModule({
  declarations: [],
  imports: [
    CommonModule
    // EffectsModule.forFeature([DtoEffects]),
    // StoreModule.forFeature(fromState.dtoFeatureKey, DTO_REDUCER)
  ]
})
export class DtoStoreModule {}
